var links = document.querySelectorAll('.menu li a');

links.forEach(function(link) {
    var img = link.querySelector('img');
    var altText = img.getAttribute('alt');
    link.setAttribute('aria-label', 'Red social oficial ' + altText);
});
